<script setup>
    import { inject } from 'vue';
    import AiIntroPage from '@/components/result/ai-literacy-2026/IntroPage.vue';   

    // 부모 컴포넌트에서 전달받은 데이터
    const schoolData = inject('schoolData');
    
    // 학교명 바인딩
    const reportData = {
        get schoolName() {
            return schoolData.value?.schul_nm || "데이터 로딩 중...";
        },
        get schul_type() {// 학교급 추가 (학급,학생이랑 변수명 맞춰서)
            return schoolData.value?.schul_type || "E";
        }
    };
</script>
<template>
    <div class="report-inner">         
        <AiIntroPage
            reportType="principal"
            :reportData="reportData"
        />
    </div>
</template>
